import { CARRIERS } from '../ShipmentForm/constants';
import { Part, PartUsage, PartV2 } from './types.d';
export { getWorkorderStatusId } from '../utils/partsUtils';

export const RETURN_INSTRUCTION_OPTIONS_RETURNABLE = [
  { label: 'Return the part within 24 hours', value: 'Return within 24 hours' },
  { label: 'Return the part within 48 hours', value: 'Return within 48 hours' },
  { label: 'Return the part within 3 days', value: 'Return within 3 days' },
  { label: 'Return the part within 5 days', value: 'Return within 5 days' },
];

export const RETURN_INSTRUCTION_OPTIONS_NON_RETURNABLE = [
  { label: 'Leave the part on site', value: 'Leave part on site' },
  { label: 'Dispose of the part (reuse, recycle, or discard)', value: 'Dispose part' },
];

export const SELECT_OPTIONS = [{
  label: 'Yes',
  value: 'Yes',
}, {
  label: 'No',
  value: 'No',
}, {
  label: '',
  value: '',
}];

export const RETAINED_BY_CUSTOMER_OPTIONS = [
  {
    label: 'Yes',
    value: '1',
  },
  {
    label: 'No',
    value: '0',
  },
];

export const USAGE_CODES = [
  'Used',
  'Not used',
  'Not received',
  'Does not work',
  'Damaged in transit',
  'Wrong part',
];

export const getInitialRetainedByCustomer = (
  customerRetained: string,
): string => {
  if (!customerRetained) {
    return '';
  }
  if (customerRetained === 'Yes') {
    return '1';
  }
  return '0';
};

export const getUsageHeader = (
  externalId = '',
  externalNumber = '',
  description = '',
): string => {
  if (!externalId && !externalNumber && !description) {
    return '-';
  }
  return `${externalId} - ${externalNumber} - ${description}`;
};

export const convertPartDataToV1Payload = (
  newPart: Part,
  partUsageData: PartUsage,
): PartV2 => {
  const isReturnable = newPart?.returnable === 'Yes';
  const partData = {
    external_id: newPart.externalId,
    description: newPart.description,
    external_number: newPart.externalNumber,
    return_policy: {
      is_returnable: isReturnable,
      ...(newPart?.returnInstruction && {
        return_instruction: newPart.returnInstruction,
      }),
    },
    note: partUsageData?.note || '',
    incoming_tracking: {},
    return_tracking: {},
  } as PartV2;

  if (partUsageData?.usageCode) {
    partData.usage_code = {
      name: partUsageData.usageCode,
    };
  }

  if (newPart?.trackingNumber) {
    partData.incoming_tracking = {
      tracking_id: newPart.trackingNumber,
      carrier_name: newPart?.carrier === 'other' ?
        newPart?.carrierOther : CARRIERS.find((carrier) => carrier.value === newPart?.carrier)?.label || '',
    };
  }

  const customerRetainedInt = parseInt(partUsageData?.customerRetained, 10) || 0;
  if (!customerRetainedInt && partUsageData?.returnTracking) {
    partData.return_tracking = {
      tracking_id: partUsageData.returnTracking || '',
      carrier_name:
        partUsageData.returnCarrier === 'other' ?
          partUsageData.returnCarrierOtherName : CARRIERS.find((carrier) => carrier.value === partUsageData?.returnCarrier)?.label || '',
      not_returned_reason: null,
    };
  } else {
    partData.return_tracking = {
      tracking_id: '',
      carrier_name: '',
      not_returned_reason: customerRetainedInt === 1 ? 'Customer retained' : null,
    };
  }
  return partData;
};
